document.addEventListener('DOMContentLoaded', function () {
  var ZOOM = 2;
  var TRANSITION_IN = 'transform 320ms cubic-bezier(0.22, 0.61, 0.36, 1)';
  var TRANSITION_OUT = 'transform 360ms cubic-bezier(0.22, 0.61, 0.36, 1)';

  var mediaList = document.querySelector('[data-product-gallery-list]');
  if (!mediaList) return;

  var isDesktopHover = function () {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  };

  var TILE_SELECTOR = '.product-gallery__media--image, .product-gallery__media--external_video';

  var activeImg = null;
  var activeTile = null;
  var rafId = null;
  var lastEvent = null;

  var cursorEl = null;
  var ensureCursor = function () {
    if (cursorEl) return cursorEl;
    cursorEl = document.createElement('div');
    cursorEl.className = 'gallery-zoom-cursor';
    cursorEl.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cursorEl);
    return cursorEl;
  };

  var showCursor = function (x, y) {
    var cur = ensureCursor();
    cur.style.left = x + 'px';
    cur.style.top = y + 'px';
    cur.classList.add('is-visible');
  };

  var hideCursor = function () {
    if (cursorEl) cursorEl.classList.remove('is-visible');
  };

  var clearImg = function () {
    if (!activeImg) return;
    activeImg.style.transition = TRANSITION_OUT;
    activeImg.style.transform = '';
    activeImg.style.transformOrigin = '';
    activeImg = null;
    activeTile = null;
  };

  var updateOrigin = function () {
    rafId = null;
    if (!lastEvent || !activeImg || !activeTile) return;

    var rect = activeTile.getBoundingClientRect();
    var x = ((lastEvent.clientX - rect.left) / rect.width) * 100;
    var y = ((lastEvent.clientY - rect.top) / rect.height) * 100;
    activeImg.style.transformOrigin = x + '% ' + y + '%';

    showCursor(lastEvent.clientX, lastEvent.clientY);
  };

  var onMove = function (e) {
    if (!isDesktopHover()) return;

    var tile = e.target.closest(TILE_SELECTOR);
    if (!tile || !mediaList.contains(tile)) {
      clearImg();
      hideCursor();
      return;
    }

    var img = tile.querySelector('.lazy-img img') || tile.querySelector('iframe');
    if (!img) return;

    if (img !== activeImg) {
      clearImg();
      activeImg = img;
      activeTile = tile;
      activeImg.style.transition = TRANSITION_IN;
      activeImg.style.transform = 'scale(' + ZOOM + ')';
    }

    lastEvent = e;
    if (!rafId) rafId = requestAnimationFrame(updateOrigin);
  };

  var onLeave = function () {
    lastEvent = null;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    clearImg();
    hideCursor();
  };

  mediaList.addEventListener('pointermove', onMove);
  mediaList.addEventListener('pointerleave', onLeave);
  window.addEventListener('blur', onLeave);
});
